var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CardSelect',{class:[
    'vast-service-order-now-network',
    {
      'vast-service-order-now-network--disabled': _vm.disabled,
      'vast-service-order-now-network--selected': _vm.selectedNetworkId === _vm.network.id,
    }
  ],attrs:{"value":_vm.network.id},model:{value:(_vm.selectedNetworkId),callback:function ($$v) {_vm.selectedNetworkId=$$v},expression:"selectedNetworkId"}},[(_vm.network.icon)?_c('div',{staticClass:"vast-service-order-now-network__logo",style:(_vm.iconStyle)}):_vm._e(),_c('div',{staticClass:"vast-service-order-now-network__label"},[_vm._v(" "+_vm._s(_vm.networkName)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }